<template>
  <div>
    <div class="image" :style="'background-image: url(' + selectedImage + ')'">
    </div>
    <div class="controls" ref="controls">
      <!--<div><v-icon>chevron_left</v-icon></div>-->
      <div class="thumbnails">
        <div v-for="(image, index) in images" :key="image"
             :style="thumbnailStyle(index)"
             :ref="'thumbnail' + index"
             @click="selectThumbnail(index)">
        </div>
      </div>
      <!--<div><v-icon>chevron_right</v-icon></div>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PfxCarousel',
    props: {
      images: {
        type: Array,
        required: true
      },
      color: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        selectedIndex: 0,
        scrollOffset: 0,
        scrollToRight: null
      }
    },
    computed: {
      selectedImage() {
        return this.images[this.selectedIndex]
      }
    },
    methods: {
      thumbnailStyle(index) {
        const borderColor = this.selectedIndex === index ? this.color : '#fff'
        return {
          cursor: 'pointer',
          backgroundImage: 'url(' + this.images[index] + ')',
          border: '2px solid ' + borderColor
        }
      },

      selectThumbnail(index) {
        this.selectedIndex = index
        index = index - 2; if (index < 0) index = 0
        const img = this.$refs['thumbnail' + index][0]
        this.scroller(img.offsetLeft)
      },

      scroller(scrollOffset) {
        const speed = 7
        const c = this.$refs.controls.scrollLeft // current offset

        if (scrollOffset !== undefined) { // variable if set when clicked, not during scroller (triggered by timeout)
          this.scrollOffset = scrollOffset
          this.scrollToRight = c < this.scrollOffset
        }

        if (this.scrollToRight && c < this.scrollOffset) {
          this.$refs.controls.scrollLeft += speed
        } else if (!this.scrollToRight && c > this.scrollOffset) {
          this.$refs.controls.scrollLeft -= speed
        } else {
          return
        }

        setTimeout(this.scroller, 1)
      }
    }
  }
</script>

<style lang="scss" scoped>

  .image {
    width: 100%;
    height: 25rem;
    background-position: center;
    background-size: cover;
    display: inline-block;
  }

  .controls {
    width: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    white-space: nowrap;

    div {
      display: inline-block;
    }
    .thumbnails {
      position: relative;
      width: 100%;
      div {
        width: 18%;
        margin: 0 2px 0 0;
        height: 4rem;
        background-position: center;
        background-size: cover;
      }
      div:last-child { margin-right: 0; }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/PfxCarousel.vue